import {
	TAGGED_DATE_EDIT_BUTTON_CLICKED,
	TAGGED_DATE_EDIT_BUTTON_CLICKED_RESET,
	UPDATE_TAGGED_DATE_REQUEST,
	UPDATE_TAGGED_DATE_REQUEST_FAILED,
	UPDATE_TAGGED_DATE_REQUEST_RESET,
	UPDATE_TAGGED_DATE_REQUEST_SUCCESS,
} from "../types"

export const taggedDateButtonClicked = () => ({
	type: TAGGED_DATE_EDIT_BUTTON_CLICKED,
})

export const taggedDateButtonClickedReset = () => ({
	type: TAGGED_DATE_EDIT_BUTTON_CLICKED_RESET,
})

export const updateTaggedDate = (data) => ({
	type: UPDATE_TAGGED_DATE_REQUEST,
	payload: data,
})

export const updateTaggedDateSuccess = (data) => ({
	type: UPDATE_TAGGED_DATE_REQUEST_SUCCESS,
	payload: data,
})

export const updateTaggedDateFailed = (data) => ({
	type: UPDATE_TAGGED_DATE_REQUEST_FAILED,
	payload: data,
})

export const updateTaggedDateReset = () => ({
	type: UPDATE_TAGGED_DATE_REQUEST_RESET,
})
